export default {"src":"/_next/static/media/australiaFlag.728af145.svg","height":38,"width":55,"blurWidth":0,"blurHeight":0};